import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutServive {

  private messageSource = new BehaviorSubject<boolean>(false);
  currentMessage = this.messageSource.asObservable();

  private messageSourceUserLogin = new BehaviorSubject<boolean>(false);

  currentUserLogin = this.messageSourceUserLogin.asObservable();

  currentUserCognito = this.messageSourceUserLogin.asObservable();

  changeMessage(message: boolean): void {
    this.messageSource.next(message);
  }

  setUserLoginStatus(flag: boolean): void {
    this.messageSourceUserLogin.next(flag);
  }


  setCognitoUserLoginStatus(flag: boolean): void {
    this.setUserLoginStatus(flag);
  }

  removeAllCookies(): void {
    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name =
        eqPos > -1
          ? cookie.substring(0, eqPos).trim()
          : cookie.trim();

      document.cookie =
        name +
        '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
    }
  }
}